<template>
  <div id="pageBreeds">
    <v-container grid-list-xl fluid>
      <v-btn class="btn-add" color="white" small absolute fab :to="{ name: 'AuxBreedNew'}">
        <v-icon>add</v-icon>
      </v-btn>
      <v-container fill-height fluid>
        <v-layout fill-height>
          <v-flex xs2>Id</v-flex>
          <v-flex xs3>Nome</v-flex>
        </v-layout>
      </v-container>
      <div class="text-xs-center">
        <v-progress-circular indeterminate color="primary" v-if="paginatationDisabled"></v-progress-circular>
      </div>
      <v-card
        class="card-finish"
        v-for="(finish, index) in breeds.data"
        :key="`finish${finish.id}`"
      >
        <v-container>
          <v-layout>
            <v-flex xs2>
              <p style="margin: 6px 0px;">{{finish.id}}</p>
            </v-flex>
            <v-flex xs3>
              <p style="margin: 6px 0px;">{{finish.name}}</p>
            </v-flex>
            <v-flex xs7 class="text-xs-right">
              <v-btn
                fab
                small
                :to="{ name: 'AuxBreedEdit', params: { id: finish.id }}"
                color="primary"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn fab small color="error" @click.stop="clickDeleteFinish(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <app-pagination
        v-if="breeds && breeds.pagination"
        :pagination="breeds.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="changePage"
      ></app-pagination>
      <app-confirm-modal
        :message="deleteMessage"
        :dialog="dialog"
        :modalType="modalType"
        v-on:choose="deleteFinish"
      ></app-confirm-modal>

      <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from '../../../plugins/api'
import AppPagination from '../../../components/Pagination'
import ConfirmModal from '../../../components/ConfirmModal'

export default {
  components: {
    'app-pagination': AppPagination,
    'app-confirm-modal': ConfirmModal
  },
  data: function() {
    return {
      breeds: {},
      paginatationDisabled: false,
      dialog: false,
      deleteFinishId: null,
      deleteMessage: '',
      modalType: null,
      snackbar: {}
    }
  },

  computed: {},

  mounted: function() {
    this.getAuxBreed()
  },

  methods: {
    getAuxBreed: function(page) {
      this.paginatationDisabled = true
      this.breeds.data = []
      appApi
        .getAuxBreeds({ page: page ? page : 1 })
        .then(result => {
          this.breeds = result.data
          this.paginatationDisabled = false
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    changePage(page) {
      this.getAuxBreed(page)
    },
    clickDeleteFinish(index) {
      this.dialog = true
      this.deleteFinishId = index
      this.modalType = 'error'
      this.deleteMessage =
        'Tem certeza que deseja deletar <strong>' +
        this.breeds.data[index].name +
        '</strong>?'
    },
    deleteFinish(confirm) {
      this.dialog = false
      if (confirm) {
        appApi
          .deleteAuxBreed(this.breeds.data[this.deleteFinishId].id)
          .then(() => {
            this.changePage(1)
            this.snackbar = {
              show: true,
              color: 'green',
              text: 'Apagado com sucesso.'
            }
          })
          .catch(() => {
            this.changePage(1)
            this.snackbar = {
              show: true,
              color: 'error',
              text: 'Não foi possível apagar.'
            }
          })
      }
    }
  }
}
</script>
<style scoped lang="css">
#pageBreeds {
  position: relative;
}
#pageBreeds .btn-add {
  position: fixed;
  top: 90px;
  left: calc(100% - 60px);
}
#pageBreeds .card-finish {
  margin-bottom: 10px;
}
</style>

